import { BaseRouteService } from "core/services";

class FacilityOrderPatientValidationRouteService extends BaseRouteService {
	constructor() {
		super("facility-order-patient-validations");	
	}
	
	find(filter) {
		return super.find(`${this.base}/{?searchQuery,page,rpp,sort,embed,fields,facilityOrderTemplateId}`, filter);
	}	

	bulkUpdate(resource) {
        return super.update(this.base + '/batch', resource);
    }
}

export default FacilityOrderPatientValidationRouteService;
